import "./VLSegmented.module.scss";
import { Segmented, SegmentedProps } from "antd";
import classNames from "classnames";

export const VLSegmented = ({ className, ...props }: SegmentedProps) => {
  return <Segmented {...props} className={classNames(className)} />;
};
